<template>
  <div>
    <v-layout wrap justify-center class="whiteBackground">
      <v-flex xs9>
        <v-layout wrap justify-space-between class="fullWindowHeight" align-center>
          <v-flex xs12>
            <v-layout wrap>
              <v-spacer/>
              <v-flex xs12 sm7>
                <h1 style="margin-top: 15px; font-size:2.3em" class="primary--text"><span class="secondary--text">ESN</span> Web Services</h1>
                <div class="primary--text" style="position: relative; margin-top: -10px"><small><b>{{ $t('1a') }}</b></small></div>
              </v-flex>
              <v-flex xs12 sm4>
              </v-flex>
              <v-spacer/>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-spacer/>
              <v-flex xs12 sm7>
                <h1 style="margin-top: 80px; font-size:2.5em">{{ $t('1b') }}<br><span v-html="$t('1c')"/><br></h1>
                <h2 class="mt-10 secondary--text">{{ $t('1d') }}</h2>
                <div class="mt-3">
                  <v-btn :to="'/book-demo' + langParamStr" class="secondary mt-8">{{ $t('bookDemo') }}</v-btn>
                </div>
              </v-flex>
              <v-flex xs12 sm4 text-center :class="{ 'my-12' : $vuetify.breakpoint.xs }">
                <img :src="images.main" :height="$vuetify.breakpoint.xs ? null : '450px'">
              </v-flex>
              <v-spacer/>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-center :class="{ 'mb-12' : $vuetify.breakpoint.xs }">
            <div><small><b>{{ $t('trustedBy') }}</b></small></div>
            <v-layout wrap>
              <v-spacer/>
              <v-flex xs5 sm2>
                <img :src="images.akka_logo" height="75px" class="mt-4">
              </v-flex>
              <v-flex xs5 sm2>
                <img :src="images.hnservices_logo" height="95px" class="">
              </v-flex>
              <v-flex xs5 sm2>
                <img :src="images.fenyxconsult_logo" height="75px" class="mt-3">
              </v-flex>
              <v-flex xs5 sm2>
                <img :src="images.ridchadata_logo" height="55px" class="mt-6 ml-6">
              </v-flex>
              <v-spacer/>
            </v-layout>
          </v-flex>
          <v-flex xs12 text-center v-if="!$vuetify.breakpoint.xs">
            <a @click="scrollToTestimonialSection()">
              <div><v-icon style="font-size:3em">mdi-chevron-down</v-icon></div>
            </a>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center class="section whiteBackground" id="testimonialSection">
      <v-flex xs11 sm7>
        <v-layout wrap align-center class="section whiteBackground">
          <v-flex xs12 py-12 :class="{'px-12': $vuetify.breakpoint.xs}">

            <v-card class="px-6 pt-3 pb-8 mt-8">
              <v-layout wrap justify-space-around>
                <v-flex xs6 text-end :class="{ 'pr-2': !$vuetify.breakpoint.xs}">
                  <img :src="images.akka_logo" height="70px" class="mb-2">
                </v-flex>
                <v-flex xs6 :class="{ 'pl-2': !$vuetify.breakpoint.xs}">
                  <v-rating readonly class="mt-3" size="20" :dense="$vuetify.breakpoint.xs" length="5" :value="5" color="yellow darken-2" background-color="yellow darken-2"></v-rating>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-row align="center" justify="center">
                    <v-col cols="auto" sm="2" xs="12" class="text-center">
                      <v-avatar :size="75" style="transform: rotate(-17deg);">
                        <v-img :src="images.laurencecarre_avatar"/>
                      </v-avatar>
                    </v-col>
                    <v-col cols="auto" sm="10" xs="12" class="py-0">
                      <div><b>{{ $t('testimonialAkka1') }}</b></div>
                      <div><b>{{ $t('testimonialAkka2') }}</b></div>
                      <div class="testimonialComment mt-2">&laquo; {{ $t('testimonialAkka3') }} &raquo;</div>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-card>

            <v-card class="px-6 pt-3 pb-8 mt-12">
              <v-layout wrap>
                <v-flex xs6 text-end pr-8>
                  <img :src="images.hnservices_logo" height="85px" class="mb-1">
                </v-flex>
                <v-flex xs6 pl-2>
                  <v-rating readonly class="mt-6" size="20" :dense="$vuetify.breakpoint.xs" length="5" :value="5" color="yellow darken-2" background-color="yellow darken-2"></v-rating>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-row align="center" justify="center">
                    <v-col cols="auto" sm="2" xs="12" class="text-center">
                      <v-avatar :size="75">
                        <v-img :src="images.ornellagianessi_avatar"/>
                      </v-avatar>
                    </v-col>
                    <v-col cols="auto" sm="10" xs="12" class="py-0">
                      <div><b>{{ $t('testimonialHnServices1') }}</b></div>
                      <div><b>{{ $t('testimonialHnServices2') }}</b></div>
                      <div class="testimonialComment mt-2">&laquo; {{ $t('testimonialHnServices3') }} &raquo;</div>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-card> 

            <v-card class="px-6 pt-3 pb-8 mt-12" :class="{ 'mb-12': $vuetify.breakpoint.xs}">
              <v-layout wrap justify-space-around>
                <v-flex xs6 text-end pr-8>
                  <img :src="images.fenyxconsult_logo" height="70px" class="mb-2">
                </v-flex>
                <v-flex xs6 pl-2>
                  <v-rating readonly class="mt-4" size="20" :dense="$vuetify.breakpoint.xs" length="5" :value="5" color="yellow darken-2" background-color="yellow darken-2"></v-rating>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs12>
                  <v-row align="center" justify="center">
                    <v-col cols="auto" sm="2" xs="12" class="text-center">
                      <v-avatar :size="75">
                        <v-img :src="images.aubrydefernez_avatar"/>
                      </v-avatar>
                    </v-col>
                    <v-col cols="auto" sm="10" xs="12" class="py-0">
                      <div><b>{{ $t('testimonialFenyx1') }}</b></div>
                      <div><b>{{ $t('testimonialFenyx2') }}</b></div>
                      <div class="testimonialComment mt-2">&laquo; {{ $t('testimonialFenyx3') }} &raquo;</div>
                    </v-col>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 text-center v-if="!$vuetify.breakpoint.xs">
        <a @click="scrollToTimeSection()">
          <div style="position: relative; top: 10px"><small>{{ $t('1f') }}</small></div>
          <div><v-icon style="font-size:3em">mdi-chevron-down</v-icon></div>
        </a>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-space-between class="section whiteBackground" id="timeSection">
      <v-flex xs12 sm5>
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.time" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm6>
        <v-layout wrap align-center class="section whiteBackground">
          <v-flex xs12 :class="{'px-12': $vuetify.breakpoint.xs}">
            <h1 class="sectionTitle">{{ $t('2a') }}</h1>
            <h2 class="sectionSubtitle secondary--text">{{ $t('2b') }}</h2>
            <div class="sectionParagraph">{{ $t('2c') }}</div>
            <div><b>{{ $t('2d') }}</b></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
    </v-layout>

    <v-layout wrap justify-space-between class="section whiteBackground">
      <v-flex xs12 sm5 v-if="$vuetify.breakpoint.xs">
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.simple" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm6>
        <v-layout wrap align-center class="section whiteBackground">
          <v-flex xs12 :class="{'px-12': $vuetify.breakpoint.xs}">
            <h1 class="sectionTitle"><span v-html="$t('3a')"/></h1>
            <h2 class="sectionSubtitle secondary--text">{{ $t('3b') }}</h2>
            <div class="sectionParagraph">{{ $t('3c') }}</div>
            <div><b>{{ $t('3d') }}</b></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm5 v-if="!$vuetify.breakpoint.xs">
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.simple" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap justify-space-between class="section whiteBackground">
      <v-flex xs12 sm5>
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.format" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm6>
        <v-layout wrap align-center class="section whiteBackground">
          <v-flex xs12 :class="{'px-12': $vuetify.breakpoint.xs}">
            <h1 class="sectionTitle">{{ $t('4a') }}</h1>
            <h2 class="sectionSubtitle secondary--text">{{ $t('4b') }}<br>{{ $t('4c') }}</h2>
            <div class="sectionParagraph">
              {{ $t('4d') }}<br>
              {{ $t('4e') }}
            </div>
            <div><b>{{ $t('4f') }}</b></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
    </v-layout>

    <v-layout wrap justify-space-between class="section whiteBackground">
      <v-flex xs12 sm5 v-if="$vuetify.breakpoint.xs">
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.securedData" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm6>
        <v-layout wrap align-center class="section whiteBackground">
          <v-flex xs12 :class="{'px-12': $vuetify.breakpoint.xs}">
            <h1 class="sectionTitle">{{ $t('6a') }}</h1>
            <h2 class="sectionSubtitle secondary--text"><span v-html="$t('6b')"/></h2>
            <div class="sectionParagraph">{{ $t('6c') }}</div>
            <div><b>{{ $t('6d') }}</b></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-spacer/>
      <v-flex xs12 sm5 v-if="!$vuetify.breakpoint.xs">
        <v-layout wrap align-center class="section greyBackground">
          <v-flex xs12 text-center>
            <img :src="images.securedData" :height="$vuetify.breakpoint.xs ? null : '350px'">
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    

    <v-layout wrap justify-center align-center pb-12 class="fullWindowHeight whiteBackground">
      <v-flex xs12 sm6 text-center :class="{'px-12': $vuetify.breakpoint.xs}">
        <!-- <h1 style="font-size: 2.5em">{{ $t('5a') }}</h1> -->
        <h1 class="secondary--text" style="font-size: 2.5em">{{ $t('5b') }}</h1>
        <div class="my-6 py-3" style="font-size: 1.25em">{{ $t('5c') }}<br><b>{{ $t('5d') }}</b></div>
        <v-btn :to="'/book-demo' + langParamStr" class="secondary mt-4" :class="{'mb-12': $vuetify.breakpoint.xs}">{{ $t('5e') }}</v-btn>
      </v-flex>
      <v-flex xs12 sm6 pt-6>
        <v-layout wrap justify-center>
          <v-flex xs11 sm10>
            <pricing-plan/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout wrap class="whiteBackground pb-1">
      <v-flex xs12 sm6>
      </v-flex>
      <v-flex xs12 sm6 text-center>
        <div>
          <small>
            <a href="mailto:martin@esnwebservices.com">martin@esnwebservices.com</a>
            <span>{{ $t('footer2a') }}</span>
            <span>{{ $t('footer1') }}</span>
            <span>{{ $t('footer2a') }}</span>
            <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/esnwebservices-prod.appspot.com/o/public%2FCGU%20ESN%20Web%20Services.pdf?alt=media&token=e888057c-0e79-4bd7-bdbd-05afc66c13f9">{{ $t('footer2b') }}</a>
          </small>
        </div>
      </v-flex>
      <v-spacer/>
    </v-layout>
  </div>
</template>


<script>
import PricingPlan from '@/components/PricingPlan.vue'

export default {
  components: {
    PricingPlan
  },
  data: () => ({
    images: {
      main: require('@/assets/app/images/personal_data__flatline.svg'),
      time: require('@/assets/app/images/fast_working.svg'),
      simple: require('@/assets/app/images/data_storage_flatline.svg'),
      format: require('@/assets/app/images/artificial_intelligence_flatline2.svg'),
      securedData: require('@/assets/app/images/security_flatline.svg'),
      akka_logo: require('@/assets/app/images/akka_logo.png'),
      hnservices_logo: require('@/assets/app/images/hnservices_logo.png'),
      fenyxconsult_logo: require('@/assets/app/images/fenyxconsult_logo.png'),
      ridchadata_logo: require('@/assets/app/images/ridchadata_logo.png'),
      laurencecarre_avatar: require('@/assets/app/images/laurencecarre.jpeg'),
      ornellagianessi_avatar: require('@/assets/app/images/ornellagianessi.jpeg'),
      aubrydefernez_avatar: require('@/assets/app/images/aubrydefernez.jpeg'),
    },
  }),
  computed: {
    langParamStr() {
      const lang = this.$route.query.lang
      if (lang && lang !== 'fr') {
        return `?lang=${lang}`
      }
      return ''
    }
  },
  methods: {
    scrollToTestimonialSection() {
      document.getElementById('testimonialSection').scrollIntoView({behavior : "smooth" })
    },
    scrollToTimeSection() {
      document.getElementById('timeSection').scrollIntoView({behavior : "smooth", block: "center" })
    }
    // scrollToSection(sectionNumber) {
    //   window.scrollBy({
    //     top: (window.innerHeight + 48) * sectionNumber,
    //     behavior : "smooth"
    //   })
    // }
  }
}

</script>

<style scoped>
  .section {
    min-height: 115vh
  }

  @media only screen and (max-width: 600px) {
    .section {
      min-height: 80vh
    }
  }

  .sectionTitle {
    margin-bottom: 0px
  }
  .sectionSubtitle {
    margin-bottom: 20px
  }
  .sectionParagraph {
    margin-bottom: 10px
  }

  .testimonialComment {
    font-size: 0.95em
  }
</style>

<i18n>
{
  "fr": {
    "1a": "L'intelligence artificielle pour ESN",
    "1b": "Notre IA crée instantanément",
    "1c": "le dossier de compétences<br>à partir du CV",
    "1d": "Au format exact de votre ESN.",
    "1e": "Créez votre compte",
    "1f": "Comment ça marche ?",
    "bookDemo": "Planifier une démo",
    "trustedBy": "Ils nous font confiance :",

    "2a": "Nous faisons gagner un temps fou aux ingénieurs d’affaires d'ESN",
    "2b": "Finis les interminables copier-collers de CV.",
    "2c": "Entraînée sur des milliers de CV, notre intelligence artificielle est spécialisée pour en extraire les informations pertinentes du candidat puis créer votre dossier de compétences selon votre format.",
    "2d": "En quelques secondes.",
    
    "3a": "Uploadez un CV,<br>Recevez un dossier de compétences.",
    "3b": "C'est simplissime.",
    "3c": "Et téléchargez-le en un clic en fichier Word.",
    "3d": "Rapide et intuitif.",

    "4a": "Les dossiers générés sont à votre format",
    "4b": "Nous adaptons notre solution à votre ESN.",
    "4c": "Pas l'inverse.",
    "4d": "Polices d'écriture, logos, style des titres, disposition des sections...",
    "4e": "Expériences professionnelles, compétences techniques, formation, certifications, langues...",
    "4f": "Tout est organisé comme vous le souhaitez.",

    "5a": "Prêt à automatiser ?",
    "5b": "Essayez gratuitement",
    "5c": "Demandez une démo et testez avec",
    "5d": "10 dossiers de compétences gratuits",
    "5e": "Demander une démo",

    "6a": "Vos données sont privées et confidentielles",
    "6b": "Tout comme vos candidats, vos CVs sont à vous.<br>Pas aux concurrents.",
    "6c": "Toutes vos données sont sécurisées, privées et hébergées dans l'Union Européenne.",
    "6d": "Nous ne les partageons avec personne.",

    "footer1": "ESN Web Services © 2023 • Tous droits réservés.",
    "footer2a": " • ",
    "footer2b": "CGUs",

    "testimonialAkka1": "Laurence Carre",
    "testimonialAkka2": "Talent Acquisition Manager @ Akka Technologies North America",
    "testimonialAkka3": "ESN Web Services fait gagner un temps précieux à nos ingénieurs d'affaires.",
    "testimonialHnServices1": "Ornella Gianessi",
    "testimonialHnServices2": "Responsable Recrutement et Ressources Humaines @ HN Services",
    "testimonialHnServices3": "Nous transformons facilement n'importe quel CV en quelques clics. Et les dossiers générés correspondent parfaitement à notre format. Nos ingénieurs d'affaires gagnent tous un temps considérable chaque jour.",
    "testimonialFenyx1": "Aubry Defernez",
    "testimonialFenyx2": "Directeur des Opérations @ Fenyx Group",
    "testimonialFenyx3": "Cet outil est un vrai gagne-temps qui nous permet de nous consacrer à 100% au recrutement de nos futurs talents."

  },
  "en": {
    "1a": "AI for HR",
    "1b": "Transform candidate CVs",
    "1c": "to fit the layout and design<br>of your company CV format",
    "1d": "Done in one click.",
    "1e": "Get started",
    "1f": "Learn more",
    "bookDemo": "Book a demo",
    "trustedBy": "Trusted by",

    "2a": "A time-saving solution to empower your recruiters",
    "2b": "Say goodbye to hours of CV copy-pasting",
    "2c": "Our AI is trained on thousands of CVs to extract its relevant data and format it just the way you need it.",
    "2d": "Done in a few seconds.",
    "2e": "",
    "2f": "",

    "3a": "Just upload a CV",
    "3b": "And download the new version in the appropriate layout",
    "3c": "Your new Word document is ready to be sent to your clients.",
    "3d": "Simple. Fast. Reliable.",

    "4a": "We perfectly match your CV layout",
    "4b": "We customize our solution to respect your own design and structure",
    "4c": " ",
    "4d": "Fonts, logos, title styles, themes, sections order...",
    "4e": "Professional experiences, technical skills, functional skills, education, certifications, languages...",
    "4f": "We adapt ourselves to deliver top-quality CV.",

    "5a": "Ready for automation ?",
    "5b": "Try for free",
    "5c": "Book a demo now to get a",
    "5d": "10 CVs-free trial",
    "5e": "Book a demo",

    "6a": "Your data is secured and confidential",
    "6b": "Your CVs belong to you. Not to your competitors.",
    "6c": "Your data is private, stored securely and hosted in the European Union.",
    "6d": "We don't share it with anyone.",

    "footer1": "ESN Web Services © 2023 • All rights reserved.",
    "footer2a": " • ",
    "footer2b": "Terms of service",

    "testimonialAkka1": "Laurence Carre",
    "testimonialAkka2": "Talent Acquisition Manager @ Akka Technologies North America",
    "testimonialAkka3": "ESN Web Services saves valuable time to our business managers.",
    "testimonialHnServices1": "Ornella Gianessi",
    "testimonialHnServices2": "Recruiting & HR Manager @ HN Services",
    "testimonialHnServices3": "We easily transform any CV in just a few clics. And the generated CVs have the exact layout we need. All our business managers win a considerable amount of time every day.",
    "testimonialFenyx1": "Aubry Defernez",
    "testimonialFenyx2": "Operations Director @ Fenyx Group",
    "testimonialFenyx3": "This tool is a real timesaver enabling us to focus 100% on recruiting our next talents."
  }
}
</i18n>